class FadeSlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.slides = Array.from(this.querySelectorAll('[id^="Slide-"]'));
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.counterCurrent = this.querySelector('.slider-counter--current');
    this.dots = Array.from(this.querySelectorAll('.slider-counter__link'));
    this.currentIndex = 0;

    if (!this.slider || this.slides.length < 2) {
      this.slides[0]?.classList.add('is-active');
      return;
    }

    this.prevButton?.addEventListener('click', () => this.go(this.currentIndex - 1));
    this.nextButton?.addEventListener('click', () => this.go(this.currentIndex + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', (e) => { e.preventDefault(); this.go(i); }));

    if (this.slider.dataset.autoplay === 'true') {
      this.autoplaySpeed = Number(this.slider.dataset.speed || 5) * 1000;
      const autoplayBtn = this.querySelector('.slideshow__autoplay');
      autoplayBtn?.addEventListener('click', () => this.isPlaying ? this.pause() : this.play());
      this.addEventListener('mouseover', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());
      this.play();
    }

    this.go(0);
  }

  go(index) {
    const total = this.slides.length;
    this.currentIndex = ((index % total) + total) % total;

    this.slides.forEach((slide, i) => {
      const active = i === this.currentIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      if (active) {
        slide.removeAttribute('tabindex');
      } else {
        slide.setAttribute('tabindex', '-1');
      }
      slide.querySelectorAll('a, button').forEach((el) =>
        el.setAttribute('tabindex', active ? '0' : '-1')
      );
    });

    this.dots.forEach((dot, i) => dot.classList.toggle('active', i === this.currentIndex));
    if (this.counterCurrent) this.counterCurrent.textContent = this.currentIndex + 1;
  }

  play() {
    this.isPlaying = true;
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplayTimer);
    this.autoplayTimer = setInterval(() => this.go(this.currentIndex + 1), this.autoplaySpeed);
    this.querySelector('.slideshow__autoplay')?.classList.remove('slideshow__autoplay--paused');
  }

  pause() {
    this.isPlaying = false;
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplayTimer);
    this.querySelector('.slideshow__autoplay')?.classList.add('slideshow__autoplay--paused');
  }
}

customElements.define('fade-slideshow-component', FadeSlideshowComponent);
